import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { StyledTutorialStep } from './tutorial-steps';
import { tutorStepPropTypes } from './step-component-props';
import { LearnMore } from './learn-more';
import helpTagImage from '../../media/helpTag.png';

export const CreateYourUETTagOnce = (props) => {
  const { i18n } = props;
  const text = i18n.getString(_TL_('Create one UET tag to get the tracking code that you can use with both conversion goals and remarketing lists.'));
  const clarityTemplate = i18n.getString(_TL_('You can also use this tracking code to send behavioral data from your website to Microsoft Clarity.'));
  const content = (
    <div>
      <p>
        <ReactTemplate template={text} />
        <LearnMore i18n={i18n} topicId="app51202" ariaLabel={text} />
      </p>
      <p>
        <ReactTemplate template={clarityTemplate} />
        <LearnMore i18n={i18n} topicId="app54800" ariaLabel={clarityTemplate} />
      </p>
    </div>
  );

  return (
    <StyledTutorialStep
      title={i18n.getString(_TL_('Create your UET tag once'))}
      imageSrc={helpTagImage}
      descTemp={content}
      i18n={i18n}
    />
  );
};

CreateYourUETTagOnce.propTypes = tutorStepPropTypes;
